import { css } from "@microsoft/fast-element";
import { alignEndState, disabledState, expandedState, extraLargeState, largeState, smallState } from "../styles/states/states.js";
import { borderRadiusMedium, colorNeutralBackground1Hover, colorNeutralForeground1, colorNeutralForeground2Hover, colorNeutralForeground2Pressed, colorNeutralForegroundDisabled, colorStrokeFocus2, colorTransparentBackground, fontFamilyBase, fontSizeBase200, fontSizeBase300, fontSizeBase400, fontSizeBase500, fontWeightRegular, lineHeightBase200, lineHeightBase300, lineHeightBase400, lineHeightBase500, spacingHorizontalMNudge, spacingHorizontalS, spacingHorizontalSNudge, spacingHorizontalXS, spacingHorizontalXXS, display, colorNeutralBackground1Pressed } from "@fluentui/web-components";
import { sizeVerticalXXXL } from "@fabric-msft/theme";
export const styles = css `
  ${display("block")}

  :host {
    contain: content;
    position: relative;
  }

  :host(:focus-visible) {
    outline: none;
  }

  :host(:focus-visible) .heading {
    border-radius: ${borderRadiusMedium};
    outline: 2px solid ${colorStrokeFocus2};
  }

  :host([marker-position="start"]) .heading {
    flex-direction: row-reverse;
  }

  :host([marker-position="end"]) .heading {
    flex-direction: row;
  }

  .heading {
    display: flex;
    justify-content: space-between;
    height: ${sizeVerticalXXXL};
    align-items: center;
    position: relative;
    padding-inline: ${spacingHorizontalS} ${spacingHorizontalS};
    border-radius: ${borderRadiusMedium};
    font-family: ${fontFamilyBase};
    font-size: ${fontSizeBase300};
    font-weight: ${fontWeightRegular};
    line-height: ${lineHeightBase300};
    grid-template-columns: auto auto 1fr auto;
    padding: 0px ${spacingHorizontalMNudge};
    margin: 1px;
    gap: ${spacingHorizontalXS};
    cursor: pointer;
    color: ${colorNeutralForeground1};
    background: ${colorTransparentBackground};
    transition: background-color 0.2s ease-in-out;
  }

  .heading * {
    pointer-events: none;
  }

  .heading:hover {
    background: ${colorNeutralBackground1Hover};
    color: ${colorNeutralForeground2Hover};
  }

  .heading:active {
    background: ${colorNeutralBackground1Pressed};
    color: ${colorNeutralForeground2Pressed};
  }

  .heading-content {
    flex: 1;
    display: flex;
    align-items: center;
  }

  .content {
    display: none;
  }

  :where(.default-marker-collapsed, .default-marker-expanded),
  ::slotted(:is([slot="marker-collapsed"], [slot="marker-expanded"])) {
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    position: relative;
    height: 100%;
    transition: transform 0.2s ease-in-out;
  }

  ::slotted([slot="start"]) {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-inline-end: ${spacingHorizontalS};
  }

  :host(${disabledState}) .heading {
    color: ${colorNeutralForegroundDisabled};
    cursor: not-allowed;
  }

  :host(${disabledState}) svg {
    filter: invert(89%) sepia(0%) saturate(569%) hue-rotate(155deg)
      brightness(88%) contrast(87%);
  }

  :host(${expandedState}) .content {
    display: block;
  }

  :host(${expandedState}) .default-marker-collapsed,
  :host(${expandedState}) ::slotted([slot="marker-collapsed"]),
  :host(:not(${expandedState})) :is(.default-marker-expanded, .content),
  :host(:not(${expandedState})) ::slotted([slot="marker-expanded"]) {
    display: none;
  }

  :host(${expandedState}) ::slotted([slot="marker-expanded"]),
  :host(:not(${expandedState})) ::slotted([slot="marker-collapsed"]) {
    display: flex;
  }

  :host(${smallState}) .heading {
    font-size: ${fontSizeBase200};
    line-height: ${lineHeightBase200};
  }

  :host(${largeState}) .heading {
    font-size: ${fontSizeBase400};
    line-height: ${lineHeightBase400};
  }

  :host(${extraLargeState}) .heading {
    font-size: ${fontSizeBase500};
    line-height: ${lineHeightBase500};
  }

  :host(${alignEndState}) :slotted([slot="start"]) {
    grid-column: 1 / span 1;
  }

  :host(${alignEndState})
    :is(.default-marker-collapsed, .default-marker-expanded) {
    padding-inline-start: ${spacingHorizontalS};
    padding-inline-end: ${spacingHorizontalXXS};
  }

  :host([block]) {
    max-width: 100%;
  }

  :host(${alignEndState}) .heading {
    padding-inline: ${spacingHorizontalS};
  }

  :host(${alignEndState}:has([slot='start'])) .heading {
    padding-inline: ${spacingHorizontalSNudge} ${spacingHorizontalS};
  }
`;
//# sourceMappingURL=accordion-menu-panel.styles.js.map